import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import Reveal from "@/components/base/Reveal";

export default function CategorySection() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16" aria-labelledby="home-category-title">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-medium tracking-[0.25em] text-primary-600">CATEGORIES</p>
          <h2 id="home-category-title" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按主题分类查找
          </h2>
        </div>
        <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
          分类是粗粒度的栏目归属，适合大方向浏览；不确定从哪看起时，先选一个分类，再按标签细分。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((category, index) => (
          <Reveal key={category.slug} delay={index * 60}>
            <Link
              to={`/category/${category.slug}`}
              className="group flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${category.icon} text-xl`} />
                </span>
                <span className="text-xs tabular-nums text-foreground-400">{category.count} 条</span>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{category.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{category.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-xs text-primary-600 transition-all group-hover:gap-2">
                浏览分类
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}